import { withStyles } from "@material-ui/core";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import theme from "../../assets/theme";
const AccordionSummary = withStyles((theme) => ({
  root: {
    borderRadius: "12px 12px 0 0",
    backgroundColor: "white",
    border: "none",
    minHeight: 72,
    padding: "0 16px",
    "&$expanded": {
      minHeight: 72,
    },
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.02)",
    },
    [theme.breakpoints.down("xs")]: {
      minHeight: 56,
      padding: "0 12px",
      "&$expanded": {
        minHeight: 56,
      },
    },
  },
  content: {
    margin: "16px 0",
    "&$expanded": {
      margin: "16px 0",
    },
    [theme.breakpoints.down("xs")]: {
      margin: "12px 0",
      "&$expanded": {
        margin: "12px 0",
      },
    },
  },
  expanded: {},
}))(MuiAccordionSummary);
const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: "#fafafa",
    borderTop: "1px solid rgba(0, 0, 0, 0.06)",
    borderRadius: "0 0 12px 12px",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.5),
    },
  },
}))(MuiAccordionDetails);

export { AccordionDetails, AccordionSummary };
